
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from 'vue-property-decorator';
import WidgetMixins from '../../mixins/WidgetMixins';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';
import { mixins } from 'vue-class-component';
import AuthLayout, { IPanelRow } from './components/AuthLayout.vue';

extend('email', {
  ...email,
  message: 'Invalid email address provided',
});
extend('required', {
  ...required,
  message: 'Field is required',
});

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    AuthLayout,
  },
})
export default class ForgotPassword extends mixins(WidgetMixins) {
  email: string = '';

  panelRows: IPanelRow[] = [
    {
      icon: 'mail_outline',
      title: 'Check your inbox',
      text: 'The reset link lands in your email within a minute.',
    },
    {
      icon: 'lock',
      title: 'Your account stays safe',
      text: 'Reset links are single-use and expire quickly.',
    },
  ];

  forgotPassword(): void {
    this.$store.dispatch('auth/forgotPassword', { email: this.email });
  }
}
